import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { ROLES } from "Constantes/constants";
import { RUTAS } from "rutas";

export const RutaAdminLogin = ({ children }) => {
  const user = useSelector((state) => state.auth);
  const isAuthenticated = Boolean(user?.token);

  if (isAuthenticated) {
    const redirectPath = user.idRol === ROLES.NO_CLIENTE.ID ? RUTAS.PRINCIPAL : RUTAS.ADMIN_HOME;
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
